<script lang="ts" setup>
import { computed, useCommonIdEventData, useRoute } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import { LoginService } from '@core/services/login.service';
import { UserService } from '@core/services/user.service';
import { PROTOCOL1, PROTOCOL2, PROTOCOL3 } from '@core/utils/constant';
import LoginMiniProgram from './LoginMiniProgram.vue';
import LoginPassword from './LoginPassword.vue';
import LoginVerifyCode from './LoginVerifyCode.vue';
import LoginWechat from './LoginWechat.vue';

const route = useRoute();
const userService = useService(UserService);
const loginService = useService(LoginService);

const eventCommonData = useCommonIdEventData();

const eventData = computed(() => ({
  ...eventCommonData,
  others_uid: route.query.uid,
}));
</script>

<template>
  <a-modal
    v-model:open="loginService.visible"
    centered
    width="800px"
    :footer="null"
  >
    <div
      v-track:mk_oj_show_logon="eventData"
      class="flex flex-row items-start py-6"
    >
      <!-- <div class="w-[300px] text-center">
        <LoginWechat />
      </div> -->
      <!-- 小程序码登录 -->
      <div class="w-[300px] text-center">
        <LoginMiniProgram />
      </div>

      <a-divider
        type="vertical"
        style="height: 300px; border-color: rgba(0, 0, 0, 0.06); margin: 0 24px"
      />

      <div class="flex-1">
        <div class="px-12">
          <a-tabs
            v-model:active-key="loginService.loginType"
            :animated="false"
            :tab-bar-gutter="40"
            @change="loginService.handleChangeLoginType"
          >
            <a-tab-pane
              :key="loginService.LOGIN_TYPE_VERIFYCODE"
              force-render
              tab="短信登录"
            >
              <LoginVerifyCode />
            </a-tab-pane>
            <a-tab-pane
              :key="loginService.LOGIN_TYPE_PASSWORD"
              force-render
              tab="密码登录"
            >
              <LoginPassword />
            </a-tab-pane>
          </a-tabs>
        </div>

        <div class="ml-10 mr-8 text-center text-xs leading-[22px]">
          <a-checkbox
            v-model:checked="loginService.model.privacy"
            class="privacy-checkbox"
            @change="loginService.updateFormStatus"
          >
            <span class="text-title text-xs">同意</span>
          </a-checkbox>

          <NuxtLink
            class="!text-info hover:opacity-85"
            target="_blank"
            :to="PROTOCOL1"
            >《平台用户服务协议》</NuxtLink
          >
          <NuxtLink
            class="!text-info hover:opacity-85"
            target="_blank"
            :to="PROTOCOL2"
            >《平台隐私政策协议》</NuxtLink
          >
          <br />
          <NuxtLink
            class="!text-info hover:opacity-85"
            target="_blank"
            :to="PROTOCOL3"
            >《平台儿童隐私保护声明》</NuxtLink
          >
        </div>
      </div>
    </div>
  </a-modal>
</template>

<style scoped>
:deep(.ant-tabs-nav::before) {
  display: none;
}
:deep(.ant-tabs-ink-bar) {
  display: none;
}
:deep(.ant-tabs-tab) {
  @apply relative !pb-2 !pt-0;
}
:deep(.ant-tabs-tab:first-child::after) {
  content: ' ';
  @apply bg-colorFillSecondary absolute -right-5 h-4 w-[1px];
}
:deep(.ant-tabs-tab-btn) {
  @apply !text-colorTextQuaternary text-xl font-bold;
}
:deep(.ant-tabs-tab-active .ant-tabs-tab-btn) {
  @apply !text-colorText;
}
.privacy-checkbox :deep(.ant-checkbox) {
  @apply mt-[1px] scale-75;
}
.privacy-checkbox :deep(.ant-checkbox + span) {
  @apply pl-1 pr-0;
}
</style>
